import React, { useEffect, useState } from 'react'
import RecommendedCarousel from '@components/Slider/RecommendedCarousel'
import CartUpsell from '@components/Recommendations/CartUpsell'
import recommendedData from '@data/recommended_data.json'
import {
    findEffVariantsWithInventory,
    mapVariantsToMetafields,
    removeOutOfStockProducts,
} from '../../utils/utils'

const RECOMMENDATION_API = 'https://services.mybcapps.com/discovery/recommend'

const Recommended = React.memo(({ productIds, title, type }) => {
    const [loaded, setLoaded] = useState(false)

    // console.log('productIds in Recommended', productIds)

    let recommendedFound = false
    let recommendedTitle
    let linkText
    let link
    let recommendationType
    let limit
    let modelType
    let secondaryAlgorithm
    let widgetId

    if (recommendedData) {
        recommendedData.recommended.map((item) => {
            if (item.title === title) {
                recommendedFound = true
                recommendedTitle = item.title
                linkText = item.linkText
                link = item.link
                recommendationType = item.recommendationType
                limit = item.limit
                modelType = item.modelType
                secondaryAlgorithm = item.secondaryAlgorithm
                widgetId = item.widgetId
            }
            return null
        })
    }

    const [recommended, setRecommended] = useState({
        products: [],
        title: title,
        linkText: linkText,
        link: link,
    })

    const fetchRecommended = async (body) => {
        // console.log('body', body)
        try {
            const response = await fetch(RECOMMENDATION_API, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                },
                body: JSON.stringify(body),
            })
            let data = await response.json()

            data.products = await Promise.all(
                data.products.map(async (p) => {
                    if (
                        p.tags.includes('bundle-builder-product') &&
                        !p.title.includes('[hidden]')
                    ) {
                        p.variants = mapVariantsToMetafields(p, p.variants)
                        p.variants = await findEffVariantsWithInventory(
                            p.variants
                        )
                    }
                    return p
                })
            )
            data.products = removeOutOfStockProducts(data.products)

            console.log('products from recommended', data.products)

            return data
        } catch (error) {
            console.error('Error fetching recommendations:', error)
        }
    }

    useEffect(() => {
        // fetch data
        const body = {
            shop: 'monicaandandyonline.myshopify.com',
            recommendationType: recommendationType,
            limit: limit,
            layoutDisplay: type,
            modelType: modelType,
            secondaryAlgorithm: secondaryAlgorithm,
            wid: widgetId,
            productIds: productIds,
            collectionId: null,
            locale: 'en',
        }

        const fallbackBody = {
            shop: 'monicaandandyonline.myshopify.com',
            recommendationType: 'related-items',
            limit: limit,
            layoutDisplay: type,
            wid: widgetId,
            productIds: productIds,
            collectionId: null,
            locale: 'en',
        }

        fetchRecommended(body).then((data) => {
            if (data && data.products && data.products.length > 0) {
                let products = data.products.filter((p) => {
                    return (
                        p.title !== 'Embroidery Option' &&
                        p.id !== productIds[0] &&
                        p.product_type !== 'Classes + Events'
                    )
                })
                setRecommended({
                    ...recommended,
                    products: products,
                })
                setLoaded(true)
            } else {
                fetchRecommended(fallbackBody).then((data) => {
                    if (data && data.products && data.products.length > 0) {
                        let products = data.products.filter((p) => {
                            return (
                                p.title !== 'Embroidery Option' &&
                                p.id !== productIds[0] &&
                                p.product_type !== 'Classes + Events'
                            )
                        })
                        setRecommended({
                            ...recommended,
                            products: products,
                        })
                        setLoaded(true)
                    }
                })
            }
        })
    }, [productIds])

    return (
        <div className='recommended-outer mb-12'>
            <div className='recommended-inner'>
                {recommended && loaded && type === 'carousel' ? (
                    <RecommendedCarousel carouselData={recommended} />
                ) : null}
                {recommended && loaded && type === 'upsell' ? (
                    <CartUpsell upsellData={recommended} />
                ) : null}
            </div>
        </div>
    )
})

export default Recommended
